module.exports = __webpack_public_path__ + "img/blue_127.19de234d.png";